import createReducer from "../createReducer";
import { IPagesState } from "./types";
import { handlersPAGES } from "./handlers";

export const pagesInitialState: IPagesState = {
    list: [],
    current: null,
    isLoading: false,
    error: null,
};

export default createReducer(pagesInitialState, handlersPAGES);
